import { j as e } from "../../chunks/jsx-runtime.DGlMoOmv.js";
import * as i from "react";
import { u as T, c as M, a as H } from "../../chunks/index.stoqs9MZ.js";
import { u as k } from "../../chunks/index.B4ZV02se.js";
import { u as A } from "../../chunks/index.BZPx6jYI.js";
import { u as L } from "../../chunks/index.CD933GbG.js";
import { P as j } from "../../chunks/index.DMLWxr4u.js";
import { c as g } from "../../chunks/index.CxSWpsOB.js";
var b = "Switch", [U, V] = M(b), [q, z] = U(b), C = i.forwardRef(
  (o, d) => {
    const {
      __scopeSwitch: s,
      name: a,
      checked: t,
      defaultChecked: w,
      required: l,
      disabled: n,
      value: c = "on",
      onCheckedChange: p,
      form: r,
      ...y
    } = o, [u, h] = i.useState(null), x = k(d, (f) => h(f)), v = i.useRef(!1), S = u ? r || !!u.closest("form") : !0, [m, B] = T({
      prop: t,
      defaultProp: w ?? !1,
      onChange: p,
      caller: b
    });
    return /* @__PURE__ */ e.jsxs(q, { scope: s, checked: m, disabled: n, children: [
      /* @__PURE__ */ e.jsx(
        j.button,
        {
          type: "button",
          role: "switch",
          "aria-checked": m,
          "aria-required": l,
          "data-state": E(m),
          "data-disabled": n ? "" : void 0,
          disabled: n,
          value: c,
          ...y,
          ref: x,
          onClick: H(o.onClick, (f) => {
            B((I) => !I), S && (v.current = f.isPropagationStopped(), v.current || f.stopPropagation());
          })
        }
      ),
      S && /* @__PURE__ */ e.jsx(
        R,
        {
          control: u,
          bubbles: !v.current,
          name: a,
          value: c,
          checked: m,
          required: l,
          disabled: n,
          form: r,
          style: { transform: "translateX(-100%)" }
        }
      )
    ] });
  }
);
C.displayName = b;
var N = "SwitchThumb", P = i.forwardRef(
  (o, d) => {
    const { __scopeSwitch: s, ...a } = o, t = z(N, s);
    return /* @__PURE__ */ e.jsx(
      j.span,
      {
        "data-state": E(t.checked),
        "data-disabled": t.disabled ? "" : void 0,
        ...a,
        ref: d
      }
    );
  }
);
P.displayName = N;
var O = "SwitchBubbleInput", R = i.forwardRef(
  ({
    __scopeSwitch: o,
    control: d,
    checked: s,
    bubbles: a = !0,
    ...t
  }, w) => {
    const l = i.useRef(null), n = k(l, w), c = A(s), p = L(d);
    return i.useEffect(() => {
      const r = l.current;
      if (!r) return;
      const y = window.HTMLInputElement.prototype, h = Object.getOwnPropertyDescriptor(
        y,
        "checked"
      ).set;
      if (c !== s && h) {
        const x = new Event("click", { bubbles: a });
        h.call(r, s), r.dispatchEvent(x);
      }
    }, [c, s, a]), /* @__PURE__ */ e.jsx(
      "input",
      {
        type: "checkbox",
        "aria-hidden": !0,
        defaultChecked: s,
        ...t,
        tabIndex: -1,
        ref: n,
        style: {
          ...t.style,
          ...p,
          position: "absolute",
          pointerEvents: "none",
          opacity: 0,
          margin: 0
        }
      }
    );
  }
);
R.displayName = O;
function E(o) {
  return o ? "checked" : "unchecked";
}
var _ = C, D = P;
const F = i.forwardRef(({
  className: o,
  testId: d,
  icon: s,
  prefix: a,
  suffix: t,
  suffixFill: w,
  ...l
}, n) => {
  const c = s !== null, p = !!a || !!t, r = /* @__PURE__ */ e.jsx(_, { ref: n, className: g("tw-peer tw-inline-flex tw-h-28 tw-w-48 tw-shrink-0 tw-cursor-pointer tw-items-center tw-rounded-full tw-border-2 tw-border-transparent tw-bg-gray-400 tw-transition-colors disabled:tw-cursor-not-allowed disabled:tw-opacity-50 disabled:tw-bg-gray-600 data-[state=checked]:tw-bg-gray-900 disabled:data-[state=checked]:tw-bg-gray-600", o), "data-testid": d, ...l, children: /* @__PURE__ */ e.jsx(D, { className: g("tw-pointer-events-none tw-relative tw-flex tw-items-center tw-justify-center tw-h-24 tw-w-24 tw-rounded-full tw-bg-base-white tw-shadow-lg tw-ring-0 tw-transition-transform data-[state=checked]:tw-translate-x-20 data-[state=unchecked]:tw-translate-x-0", c && "[&>span]:tw-opacity-0 [&[data-state=checked]>span]:tw-opacity-100"), children: c && /* @__PURE__ */ e.jsx("span", { className: "tw-absolute tw-flex tw-items-center tw-justify-center tw-transition-opacity", children: s }) }) });
  return p ? w ? /* @__PURE__ */ e.jsxs("div", { className: "tw-flex tw-items-center tw-justify-between tw-w-full tw-gap-12", children: [
    r,
    t && /* @__PURE__ */ e.jsx("span", { className: "tw-body-2 tw-text-gray-600", children: t })
  ] }) : /* @__PURE__ */ e.jsxs("div", { className: "tw-inline-flex tw-items-center tw-gap-12", children: [
    a && /* @__PURE__ */ e.jsx("span", { className: "tw-body-2 tw-text-gray-600 tw-shrink-0", children: a }),
    r,
    t && /* @__PURE__ */ e.jsx("span", { className: "tw-body-2 tw-text-gray-600 tw-shrink-0", children: t })
  ] }) : r;
});
F.displayName = _.displayName;
export {
  F as Switch
};
//# sourceMappingURL=index.js.map
